import './LinearProgress.css';

export const LinearProgress = ({
  className = '',
  style,
  color = '#1d7789',
  backgroundColor = '#ccdde0',
}) => {
  return (
    <div
      className={`linear-progress-native ${className}`}
      style={{
        backgroundColor,
        ...style,
      }}
    >
      <div
        className="linear-progress-native__bar linear-progress-native__bar--primary"
        style={{ backgroundColor: color }}
      />

      <div
        className="linear-progress-native__bar linear-progress-native__bar--secondary"
        style={{ backgroundColor: color }}
      />
    </div>
  );
};

export default LinearProgress;
